import { extendTheme, type ThemeConfig } from '@chakra-ui/react';
import { sf } from './sisuForgeTokens';

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

export const theme = extendTheme({
  config,
  fonts: {
    heading: sf.fontDisplay,
    body: sf.fontSans,
  },
  colors: {
    sf: {
      bg: sf.bg,
      surface: sf.surface,
      primaryDeep: sf.primaryDeep,
      steelBlue: sf.steelBlue,
      accent: sf.accent,
      border: sf.border,
      text: sf.text,
      muted: sf.textMuted,
    },
  },
  semanticTokens: {
    colors: {
      'chakra-body-text': sf.text,
      'chakra-body-bg': sf.bg,
      'chakra-border-color': sf.border,
    },
  },
  styles: {
    global: {
      'html, body': {
        bg: sf.bg,
        color: sf.text,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 600,
        borderRadius: sf.radiusMd,
        minH: sf.touchMin,
        px: 5,
        _focusVisible: {
          boxShadow: `0 0 0 2px ${sf.bg}, 0 0 0 4px ${sf.accent}`,
        },
      },
      variants: {
        solid: {
          bg: sf.primaryDeep,
          color: sf.text,
          borderWidth: '1px',
          borderColor: sf.steelBlue,
          _hover: {
            bg: sf.steelBlue,
            boxShadow: `0 0 12px ${sf.accentGlow}`,
          },
          _active: { bg: sf.primaryDeep },
        },
        outline: {
          borderWidth: '1px',
          borderColor: sf.border,
          color: sf.text,
          bg: sf.surface,
          _hover: {
            borderColor: sf.accent,
            boxShadow: `0 0 10px ${sf.accentGlow}`,
          },
        },
        ghost: {
          color: sf.accent,
          _hover: { bg: 'rgba(58, 141, 255, 0.08)' },
        },
      },
    },
    Link: {
      baseStyle: {
        color: sf.accent,
        _hover: { color: sf.text, textDecoration: 'underline' },
      },
    },
    Code: {
      baseStyle: {
        color: sf.textMuted,
        bg: sf.surfaceElevated,
        borderWidth: '1px',
        borderColor: sf.border,
      },
    },
  },
});
